import { render, staticRenderFns } from "./Roster.vue?vue&type=template&id=57cdb81a&scoped=true"
import script from "@/components/roster/Roster.ts?vue&type=script&lang=ts&external"
export * from "@/components/roster/Roster.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/roster/roster.scss?vue&type=style&index=0&id=57cdb81a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cdb81a",
  null
  
)

export default component.exports